import { Navbar, Nav, Container, NavDropdown, Badge } from 'react-bootstrap';
import { FaShoppingCart, FaUser } from 'react-icons/fa';
import { LinkContainer } from 'react-router-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLogoutMutation } from '../slices/usersApiSlice';
import { logout } from '../slices/authSlice';
import SearchBox from './SearchBox';
import logo from '../assets/BeaCrest.jpg';
import { resetCart } from '../slices/cartSlice';
import { DateRange } from '@mui/icons-material';

const Header = () => {
  const dropdownMenuStyle = {
    zIndex: 1050,
    backgroundColor: 'lightblue',
  };

  const dropdownItemStyle = {
    backgroundColor: 'lightyellow',
  };

  const { cartItems } = useSelector((state) => state.cart);
  const { userInfo } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [logoutApiCall] = useLogoutMutation();

  const logoutHandler = async () => {
    try {
      await logoutApiCall().unwrap();
      dispatch(logout());
      dispatch(resetCart());
      navigate('/login');
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <header>
      <Navbar
        style={{ backgroundColor: '#b1e1e7', height: '80px' }}
        variant='light'
        expand='lg'
        collapseOnSelect
      >
        <Container>
          <LinkContainer to='/'>
            <Navbar.Brand>
              <img
                src={logo}
                alt='Beaumont Hospital Agency Portal'
                style={{ maxHeight: '60px', maxWidth: '100%', height: 'auto' }}
              />

              <Navbar.Text style={{ fontSize: '30px', marginLeft: '30px' }}>
                Beaumont Hospital Agency Portal
              </Navbar.Text>
            </Navbar.Brand>
          </LinkContainer>
          <Navbar.Toggle aria-controls='basic-navbar-nav' />
          <Navbar.Collapse id='basic-navbar-nav'>
            <Nav className='ms-auto'>
              <SearchBox />
              
              {userInfo ? (
                <>
                  <NavDropdown
                    title={userInfo.name}
                    id='username'
                    style={dropdownMenuStyle}
                  >
                    <LinkContainer to='/profile'>
                      <NavDropdown.Item style={dropdownItemStyle}>
                        Profile
                      </NavDropdown.Item>
                    </LinkContainer>

                    <LinkContainer to='/shiftRequests'>
                      <NavDropdown.Item style={dropdownItemStyle}>
                        Shift Requests
                      </NavDropdown.Item>
                    </LinkContainer>

                    <NavDropdown.Item onClick={logoutHandler}>
                      Logout
                    </NavDropdown.Item>
                  </NavDropdown>
                </>
              ) : (
                <LinkContainer to='/login'>
                  <Nav.Link>
                    <FaUser /> Sign In
                  </Nav.Link>
                </LinkContainer>
              )}
              
              {/* Manager Links */}
              {userInfo && userInfo.isManager && (
                <NavDropdown
                  title='Manager'
                  id='managermenu'
                  style={dropdownMenuStyle}
                >
                  <LinkContainer to='/manager/reports'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Reports
                    </NavDropdown.Item>
                  </LinkContainer>

                  <LinkContainer to='/manager/activityreport'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Activity Time Report
                    </NavDropdown.Item>
                  </LinkContainer>

                  <LinkContainer to='/manager/reports/List'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Staff Reports Lists
                    </NavDropdown.Item>
                  </LinkContainer>

                  <LinkContainer to='/manager/approveWorklist'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Approve User Worklists
                    </NavDropdown.Item>
                  </LinkContainer>

                  <LinkContainer to='/manager/approvedWorklist'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Approved / Part Approved
                    </NavDropdown.Item>
                  </LinkContainer>

                  <LinkContainer to='/manager/assignment'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Assign Privileges
                    </NavDropdown.Item>
                  </LinkContainer>

                  <LinkContainer to='/manager/assignmentView'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      View Assigned Privileges
                    </NavDropdown.Item>
                  </LinkContainer>

                  {/* Optional: Add shift management for managers too */}
                  <NavDropdown.Divider />
                  <LinkContainer to='/admin/staffWeeklySchedule'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Staff Weekly Schedule
                    </NavDropdown.Item>
                  </LinkContainer>

                  <LinkContainer to='/admin/ward-weekly-schedule'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Ward Weekly Schedule
                    </NavDropdown.Item>
                  </LinkContainer>

                   <LinkContainer to='/admin/MonthlyCalendarView'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Monthly Calendar Stats
                    </NavDropdown.Item>
                  </LinkContainer>

                  <LinkContainer to='/admin/staff-availability'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Staff Availability
                    </NavDropdown.Item>
                  </LinkContainer>


                  
                </NavDropdown>
              )}
              
              {/* Admin Links */}
              {userInfo && userInfo.isAdmin && (
                <NavDropdown
                  title='Admin'
                  id='adminmenu'
                  style={dropdownMenuStyle}
                >
                  {/* ===== NEW SHIFT MANAGEMENT PAGES ===== */}

                  <LinkContainer to='/admin/shifts'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Create Shifts
                    </NavDropdown.Item>
                  </LinkContainer>

                   <LinkContainer to='/admin/staff-availability'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Staff Availability
                    </NavDropdown.Item>
                  </LinkContainer>

                  <LinkContainer to='/admin/ward-weekly-schedule'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Ward Weekly Schedule
                    </NavDropdown.Item>
                  </LinkContainer>

                  <LinkContainer to='/admin/staffWeeklySchedule'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Staff Weekly Schedule
                    </NavDropdown.Item>
                  </LinkContainer>

                  

                  <LinkContainer to='/admin/MonthlyCalendarView'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Monthly Calendar Stats
                    </NavDropdown.Item>
                  </LinkContainer>

                 <LinkContainer to='/admin/rolling-roster'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      6-Week Rolling Roster
                    </NavDropdown.Item>
                  </LinkContainer>


                 


                  <NavDropdown.Divider />
                  
                {/* Existing shift management */}

                  <LinkContainer to='/admin/approved-filled'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Ward Shift Approval
                    </NavDropdown.Item>
                  </LinkContainer>

                  
                  
                  <LinkContainer to='/admin/userlist'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Users
                    </NavDropdown.Item>
                  </LinkContainer>

                </NavDropdown>
              )}
              
              {/* Rad Admin Links */}
              {userInfo && userInfo.isRadAdmin && (
                <NavDropdown
                  title='Radiation Admin'
                  id='radadminmenu'
                  style={dropdownMenuStyle}
                >

                    {/* Existing shift management */}
                  

                  <LinkContainer to='/admin/shiftApproval'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Shift Approval
                    </NavDropdown.Item>
                  </LinkContainer>

                  <LinkContainer to='/admin/shiftAgencyNotification'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Agency Notification
                    </NavDropdown.Item>
                  </LinkContainer>
                  
                  <LinkContainer to='/admin/shiftRequestAgency'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Agency Request
                    </NavDropdown.Item>
                  </LinkContainer>

                  <LinkContainer to='/admin/shiftRequests'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Staff Shift Requests
                    </NavDropdown.Item>
                  </LinkContainer>

                  <LinkContainer to='/admin/agencies'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Manage Agencies
                    </NavDropdown.Item>
                  </LinkContainer>
                  

                  {/* Existing rad admin shift management */}

                  <LinkContainer to='/admin/RadAdmin/radiationsafetylist'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Radiation Safety Records
                    </NavDropdown.Item>
                  </LinkContainer>

                  <LinkContainer to='/Admin/userlist/Rad'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Users
                    </NavDropdown.Item>
                  </LinkContainer>
                </NavDropdown>
              )}

              {/* Menu Links */}
              {userInfo && userInfo.name === 'andrew redmond' && (
                <NavDropdown title='Menus' id='menus' style={dropdownMenuStyle}>
                  <LinkContainer to='/admin/productlist'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Menu Items
                    </NavDropdown.Item>
                  </LinkContainer>

                  <LinkContainer to='/admin/directoratelist'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Directorates
                    </NavDropdown.Item>
                  </LinkContainer>

                  <LinkContainer to='/admin/specialitylist'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Speciality
                    </NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer to='/admin/activitylist'>
                    <NavDropdown.Item style={dropdownItemStyle}>
                      Activities
                    </NavDropdown.Item>
                  </LinkContainer>
                </NavDropdown>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;